import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, Route, Routes } from 'react-router-dom';
import { withAuthenticator } from '@aws-amplify/ui-react';
import { Search } from './routes/Search';
import { TopNav } from './components/TopNav';
import placemakrLogo from './assets/placemakr-logo.svg';
const AppRoutes = () => (_jsxs(_Fragment, { children: [_jsx(TopNav, {}), _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Search, {}) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] })] }));
function AuthHeader() {
    return (_jsxs("div", { className: "flex flex-col items-center py-6 bg-white border border-[#e5e7eb]", children: [_jsx("img", { src: placemakrLogo, alt: "Placemakr", className: "h-10 w-auto" }), _jsx("h1", { className: "mt-3 text-lg font-semibold text-midnight tracking-tight", children: "Sales Desk" })] }));
}
// Gate every route behind Cognito login against the internal/staff pool.
// Self-signup is disabled (accounts are admin-created), so hide the "Create
// Account" tab. Unauthenticated visitors get the sign-in screen; authenticated
// staff land on the search view.
export const App = withAuthenticator(AppRoutes, {
    hideSignUp: true,
    components: {
        Header: AuthHeader
    }
});
